export enum Employer {
  '12Technologies' = '12_TECHNOLOGIES',
  '3M' = '3M',
  AbbottLabs = 'ABBOTT_LABS',
  Acc = 'ACC',
  Accenture = 'ACCENTURE',
  AdvancedMicroDevices = 'ADVANCED_MICRO_DEVICES',
  Aisd = 'AISD',
  AlleganyBoardOfEducation = 'ALLEGANY_BOARD_OF_EDUCATION',
  AlisalSchoolDistrict = 'ALISAL_SCHOOL_DISTRICT',
  Amazon = 'AMAZON',
  Amd = 'AMD',
  AolTimeWarnerAustinCablevision = 'AOL_TIME_WARNER_AUSTIN_CABLEVISION',
  AppleComputers = 'APPLE_COMPUTERS',
  AppleInc = 'APPLE_INC',
  AppliedMaterials = 'APPLIED_MATERIALS',
  Ara = 'ARA',
  Arc = 'ARC',
  AscensionHealth = 'ASCENSION_HEALTH',
  ATT = 'AT&T',
  AttorneyGeneral = 'ATTORNEY_GENERAL',
  ATTWireless = 'ATT_WIRELESS',
  AustinCommunityCollege = 'AUSTIN_COMMUNITY_COLLEGE',
  AustinIndependentSchoolDistrict = 'AUSTIN_INDEPENDENT_SCHOOL_DISTRICT',
  AustinIsd = 'AUSTIN_ISD',
  AustinRadiologicalAssociation = 'AUSTIN_RADIOLOGICAL_ASSOCIATION',
  AustinRegionalClinic = 'AUSTIN_REGIONAL_CLINIC',
  AustinStateHospital = 'AUSTIN_STATE_HOSPITAL',
  BankOfAmerica = 'BANK_OF_AMERICA',
  BastropIsd = 'BASTROP_ISD',
  BeitzelCorporation = 'BEITZEL_CORPORATION',
  BernardusLodge = 'BERNARDUS_LODGE',
  Bisd = 'BISD',
  BrackenridgeHospital = 'BRACKENRIDGE_HOSPITAL',
  CalAmWater = 'CAL_AM_WATER',
  CalifDeptOfParksAndRec = 'CALIF_DEPT_OF_PARKS_AND_REC',
  CaliforniaDeptOfCorrections = 'CALIFORNIA_DEPT_OF_CORRECTIONS',
  CanterburyWoods = 'CANTERBURY_WOODS',
  CapitalMetro = 'CAPITAL_METRO',
  CarmelHillsCareCenter = 'CARMEL_HILLS_CARE_CENTER',
  CarmelRealtyCompany = 'CARMEL_REALTY_COMPANY',
  CarmelUnifiedSchoolDistrict = 'CARMEL_UNIFIED_SCHOOL_DISTRICT',
  CarmelValleyManor = 'CARMEL_VALLEY_MANOR',
  CarmelValleyRanch = 'CARMEL_VALLEY_RANCH',
  CenteneCorporation = 'CENTENE_CORPORATION',
  CharlesSchwab = 'CHARLES_SCHWAB',
  CharterCommunications = 'CHARTER_COMMUNICATIONS',
  Child = 'CHILD',
  CiscoSystems = 'CISCO_SYSTEMS',
  CityOfAustin = 'CITY_OF_AUSTIN',
  CityOfCarmel = 'CITY_OF_CARMEL',
  CityOfMonterey = 'CITY_OF_MONTEREY',
  CityOfPacificGrove = 'CITY_OF_PACIFIC_GROVE',
  CityOfSalinas = 'CITY_OF_SALINAS',
  CityOfSeaside = 'CITY_OF_SEASIDE',
  ClinicalPathologyLabratories = 'CLINICAL_PATHOLOGY_LABRATORIES',
  Cms = 'CMS',
  CSX = 'CSX',
  CommHospitalOfTheMontereyPeninsula = 'COMM_HOSPITAL_OF_THE_MONTEREY_PENINSULA',
  CommunityCare = 'COMMUNITY_CARE',
  CostcoSandCity = 'COSTCO_SAND_CITY',
  CostcoWholesale = 'COSTCO_WHOLESALE',
  CountyOfMonterey = 'COUNTY_OF_MONTEREY',
  CovenantManagementSystems = 'COVENANT_MANAGEMENT_SYSTEMS',
  Cpl = 'CPL',
  CSUMB = 'CSUMB',
  CVS = 'CVS',
  CvsPharmacy = 'CVS_PHARMACY',
  CypressHealthcarePartners = 'CYPRESS_HEALTHCARE_PARTNERS',
  CypressRidgeHealthCenter = 'CYPRESS_RIDGE_HEALTH_CENTER',
  DefenseLanguageInstitute = 'DEFENSE_LANGUAGE_INSTITUTE',
  DefenseManpowerDataCTRDOD = 'DEFENSE_MANPOWER_DATA_CTR_DOD',
  DellChildrensMedicalCenter = 'DELL_CHILDRENS_MEDICAL_CENTER',
  DellComputer = 'DELL_COMPUTER',
  DelValleIsd = 'DEL_VALLE_ISD',
  DepartmentOfHumanServices = 'DEPARTMENT_OF_HUMAN_SERVICES',
  DepartmentOfPublicSafety = 'DEPARTMENT_OF_PUBLIC_SAFETY',
  DepartmentOfVeteransAffairs = 'DEPARTMENT_OF_VETERANS_AFFAIRS',
  DeptOfVeteransAffairs = 'DEPT_OF_VETERANS_AFFAIRS',
  DioceseOfMonterey = 'DIOCESE_OF_MONTEREY',
  DoctorsOnDutyLighthouse = 'DOCTORS_ON_DUTY_LIGHTHOUSE',
  EanesIsd = 'EANES_ISD',
  EbayCom = 'EBAY_COM',
  EmersonProcessManagement = 'EMERSON_PROCESS_MANAGEMENT',
  Ercot = 'ERCOT',
  Facebook = 'FACEBOOK',
  FarmersInsuranceGroupInc = 'FARMERS_INSURANCE_GROUP_INC',
  FederalEmployees = 'FEDERAL_EMPLOYEES',
  FederalExpress = 'FEDERAL_EXPRESS',
  FederalGovernment = 'FEDERAL_GOVERNMENT',
  Fedex = 'FEDEX',
  FleetNumerical = 'FLEET_NUMERICAL',
  Flextronics = 'FLEXTRONICS',
  Freescale = 'FREESCALE',
  GarrettRegionalMedicalCenter = 'GARRETT_REGIONAL_MEDICAL_CENTER',
  GatewayCenterInc = 'GATEWAY_CENTER_INC',
  GeneralMotors = 'GENERAL_MOTORS',
  Gm = 'GM',
  GoodwillIndustries = 'GOODWILL_INDUSTRIES',
  Google = 'GOOGLE',
  GraniteConstruction = 'GRANITE_CONSTRUCTION',
  GraniteRock = 'GRANITE_ROCK',
  HartnellCollege = 'HARTNELL_COLLEGE',
  HaysCisd = 'HAYS_CISD',
  HaysConsolidatedIsd = 'HAYS_CONSOLIDATED_ISD',
  HaysIsd = 'HAYS_ISD',
  HcaHealthcare = 'HCA_HEALTHCARE',
  HealthAndHumanServicesCommission = 'HEALTH_AND_HUMAN_SERVICES_COMMISSION',
  Heb = 'HEB',
  HebGrocery = 'HEB_GROCERY',
  HewlettPackardCo = 'HEWLETT_PACKARD_CO',
  Hhs = 'HHS',
  HomeDepot = 'HOME_DEPOT',
  Homemakers = 'HOMEMAKERS',
  Hospira = 'HOSPIRA',
  HospitalCorporationOfAmerica = 'HOSPITAL_CORPORATION_OF_AMERICA',
  Hp = 'HP',
  HuttoIsd = 'HUTTO_ISD',
  HyattCarmelHighlandsInn = 'HYATT_CARMEL_HIGHLANDS_INN',
  HyattRegencyHotel = 'HYATT_REGENCY_HOTEL',
  HyattRegencyMonterey = 'HYATT_REGENCY_MONTEREY',
  IBMCorporation = 'IBM_CORPORATION',
  Indeed = 'INDEED',
  InHomeSupportiveServicesIHSS = 'IN_HOME_SUPPORTIVE_SERVICES_IHSS',
  Insperity = 'INSPERITY',
  IntelCorp = 'INTEL_CORP',
  InterimInc = 'INTERIM_INC',
  InternalRevenueService = 'INTERNAL_REVENUE_SERVICE',
  IRS = 'IRS',
  JpMorganChase = 'JP_MORGAN_CHASE',
  LakeTravisIsd = 'LAKE_TRAVIS_ISD',
  LanguageLine = 'LANGUAGE_LINE',
  Lcra = 'LCRA',
  LeanderIsd = 'LEANDER_ISD',
  LowerColoradoRiverAuthority = 'LOWER_COLORADO_RIVER_AUTHORITY',
  Lowes = 'LOWES',
  Luckys = 'LUCKYS',
  MacysMonterey = 'MACYS_MONTEREY',
  ManorIsd = 'MANOR_ISD',
  MarriotMonterey = 'MARRIOTT_MONTEREY',
  Maximus = 'MAXIMUS',
  McDonalds = 'MCDONALDS',
  MiddleburyInstituteOfIntlStudy = 'MIDDLEBURY_INSTITUTE_OF_INTL_STUDY',
  MonGeneralHospital = 'MON_GENERAL_HOSPITAL',
  MontageHealth = 'MONTAGE_HEALTH',
  MontageMedicalGroupMMG = 'MONTAGE_MEDICAL_GROUP_MMG',
  MontereyBayAquarium = 'MONTEREY_BAY_AQUARIUM',
  MontereyCountyHealthDept = 'MONTEREY_COUNTY_HEALTH_DEPT',
  MontereyCountyOfficeOfEducation = 'MONTEREY_COUNTY_OFFICE_OF_EDUCATION',
  MontereyCountySheriffDept = 'MONTEREY_COUNTY_SHERIFF_DEPT',
  MontereyCountySocialServices = 'MONTEREY_COUNTY_SOCIAL_SERVICES',
  MontereyPeninsulaCollege = 'MONTEREY_PENINSULA_COLLEGE',
  MontereyPeninsulaCountryClub = 'MONTEREY_PENINSULA_COUNTRY_CLUB',
  MontereyPeninsulaSurgeryCenter = 'MONTEREY_PENINSULA_SURGERY_CENTER',
  MontereyPeninsulaUSD = 'MONTEREY_PENINSULA_USD',
  MontereyPlazaHotel = 'MONTEREY_PLAZA_HOTEL',
  MontereySalinasTransit = 'MONTEREY_SALINAS_TRANSIT',
  Motorola = 'MOTOROLA',
  MountainLaurelMedicalCenter = 'MOUNTAIN_LAUREL_MEDICAL_CENTER',
  NationalInstruments = 'NATIONAL_INSTRUMENTS',
  NatividadHospital = 'NATIVIDAD_HOSPITAL',
  NavalPostgraduateSchool = 'NAVAL_POSTGRADUATE_SCHOOL',
  NorthCountySchool = 'NORTH_COUNTY_SCHOOL',
  NorthropGrumman = 'NORTHROP_GRUMMAN',
  NotBeingUsedAtThisTime = 'NOT_BEING_USED_AT_THIS_TIME',
  NPGSCivilian = 'NPGS_CIVILIAN',
  NxpSemiconductors = 'NXP_SEMICONDUCTORS',
  OracleCorporation = 'ORACLE_CORPORATION',
  Other = 'OTHER',
  PacificGasAndElectric = 'PACIFIC_GAS_AND_ELECTRIC',
  PacificGroveUnifiedSchoolDistrict = 'PACIFIC_GROVE_UNIFIED_SCHOOL_DISTRICT',
  PajaroSchoolDistrict = 'PAJARO_SCHOOL_DISTRICT',
  PebbleBeachCommunitySrvcs = 'PEBBLE_BEACH_COMMUNITY_SRVCS',
  PebbleBeachCompany = 'PEBBLE_BEACH_COMPANY',
  PflugervilleIsd = 'PFLUGERVILLE_ISD',
  PortolaPlazaHotel = 'PORTOLA_PLAZA_HOTEL',
  PostRanchInn = 'POST_RANCH_INN',
  PresidioCivilian = 'PRESIDIO_CIVILIAN',
  ProgressiveInsurance = 'PROGRESSIVE_INSURANCE',
  ProjectConcordiaUniversity = 'PROJECT_CONCORDIA_UNIVERSITY',
  QuailLodge = 'QUAIL_LODGE',
  RoundRockIsd = 'ROUND_ROCK_ISD',
  Rrisd = 'RRISD',
  Safeway = 'SAFEWAY',
  SalinasElemSchoolDistrict = 'SALINAS_ELEM_SCHOOL_DISTRICT',
  SalinasHighSchoolDistrict = 'SALINAS_HIGH_SCHOOL_DISTRICT',
  SalinasValleyMemorialHospital = 'SALINAS_VALLEY_MEMORIAL_HOSPITAL',
  SalinasValleyStatePrison = 'SALINAS_VALLEY_STATE_PRISON',
  Samsung = 'SAMSUNG',
  SantaCatalinaSchool = 'SANTA_CATALINA_SCHOOL',
  SantaLuciaPreserve = 'SANTA_LUCIA_PRESERVE',
  SantaRitaSchoolDistrict = 'SANTA_RITA_SCHOOL_DISTRICT',
  SetonHealthcareNetwork = 'SETON_HEALTHCARE_NETWORK',
  SetonMedicalCenter = 'SETON_MEDICAL_CENTER',
  SetonNetwork = 'SETON_NETWORK',
  SetonNorthwestHospital = 'SETON_NORTHWEST_HOSPITAL',
  SocialSecurityOfficeSalinas = 'SOCIAL_SECURITY_OFFICE_SALINAS',
  SoledadPrisonCTF = 'SOLEDAD_PRISON_CTF',
  SoledadUnifiedSchooldDistrict = 'SOLEDAD_UNIFIED_SCHOOL_DISTRICT',
  Spansion = 'SPANSION',
  Starbucks = 'STARBUCKS',
  StarbucksCoffee = 'STARBUCKS_COFFEE',
  StateFarmInsurance = 'STATE_FARM_INSURANCE',
  StateOfTexas = 'STATE_OF_TEXAS',
  StateOfTexasERS = 'STATE_OF_TEXAS_ERS',
  StateRetired = 'STATE_RETIRED',
  StDavidsHospital = 'ST_DAVIDS_HOSPITAL',
  StDavidsMedicalCenter = 'ST_DAVIDS_MEDICAL_CENTER',
  StEdwardsUniversity = 'ST_EDWARDS_UNIVERSITY',
  StevensonSchool = 'STEVENSON_SCHOOL',
  TanimuraAndAntle = 'TANIMURA_AND_ANTLE',
  Target = 'TARGET',
  TaylorFarms = 'TAYLOR_FARMS',
  TeachersRetirementSystem = 'TEACHERS_RETIREMENT_SYSTEM',
  Tesla = 'TESLA',
  TexasDepartmentOfHumanServices = 'TEXAS_DEPARTMENT_OF_HUMAN_SERVICES',
  TexasDepartmentOfPublicTransportation = 'TEXAS_DEPARTMENT_OF_PUBLIC_TRANSPORTATION',
  TexasDeptOfHumanServices = 'TEXAS_DEPT_OF_HUMAN_SERVICES',
  TexasDeptOfHwyPublicTra = 'TEXAS_DEPT_OF_HWY_PUBLIC_TRA',
  TexasGuaranteedStudentLoans = 'TEXAS_GUARANTEED_STUDENT_LOANS',
  TexasMutualInsuranceCompany = 'TEXAS_MUTUAL_INSURANCE_COMPANY',
  TexasOncology = 'TEXAS_ONCOLOGY',
  TexasStateUniversity = 'TEXAS_STATE_UNIVERSITY',
  TheHomeDepot = 'THE_HOME_DEPOT',
  TimeWarnerCable = 'TIME_WARNER_CABLE',
  TraderJoes = 'TRADER_JOES',
  TravisCounty = 'TRAVIS_COUNTY',
  TravisCountySheriffsDept = 'TRAVIS_COUNTY_SHERIFFS_DEPT',
  TrinetGroupInc = 'TRINET_GROUP_INC',
  Trs = 'TRS',
  TxGuaranteeStudentLoan = 'TX_GUARANTEE_STUDENT_LOAN',
  UCSantaCruz = 'UC_SANTA_CRUZ',
  UnitedStatesPostalService = 'UNITED_STATES_POSTAL_SERVICE',
  UniversityOfTexas = 'UNIVERSITY_OF_TEXAS',
  UPS = 'UPS',
  USAirForce = 'US_AIR_FORCE',
  USArmy = 'US_ARMY',
  USCoastGuard = 'US_COAST_GUARD',
  USMarines = 'US_MARINES',
  USNavy = 'US_NAVY',
  UsPostalService = 'US_POSTAL_SERVICE',
  Ut = 'UT',
  VentanaInn = 'VENTANA_INN',
  VeteransAdministration = 'VETERANS_ADMINISTRATION',
  VisaInternational = 'VISA_INTERNATIONAL',
  VisitingNurseAssociation = 'VISITING_NURSE_ASSOCIATION',
  Walgreens = 'WALGREENS',
  Walmart = 'WALMART',
  WellsFargo = 'WELLS_FARGO',
  WholeFoodsMarket = 'WHOLE_FOODS_MARKET',
  WilliamsonCounty = 'WILLIAMSON_COUNTY',

  // list below this line needs to be mapped 1-to-1 in EHR
  '711IvyStWaynesboro' = '711_IVY_ST_WAYNESBORO',
  '711JeffersonHwyStaunton' = '711_JEFFERSON_HWY_STAUNTON',
  '711NColterStStaunton' = '711_N_COLTER_ST_STAUNTON',
  '711RosserAveWaynesboro' = '711_ROSSER_AVE_WAYNESBORO',
  '711Verona' = '711_VERONA',
  '711WMainStWaynesboro' = '711_W_MAIN_ST_WAYNESBORO',
  '7ThDayAdventistChurch' = '7TH_DAY_ADVENTIST_CHURCH',
  AbfFreightSystemInc = 'ABF_FREIGHT_SYSTEM_INC',
  AccoridusHealthAtWaynesboro = 'ACCORIDUS_HEALTH_AT_WAYNESBORO',
  AccutecBlades = 'ACCUTEC_BLADES',
  AceHardware = 'ACE_HARDWARE',
  Adecco = 'ADECCO',
  AdiaEmploymentService = 'ADIA_EMPLOYMENT_SERVICE',
  ADMobileHomes = 'A_D_MOBILE_HOMES',
  AdomInc = 'ADOM_INC',
  AdvanceAutoPartsFishersvill = 'ADVANCE_AUTO_PARTS_FISHERSVILL',
  AdvanceAutoPartsStaunton = 'ADVANCE_AUTO_PARTS_STAUNTON',
  AdvanceAutoPartsStuartsDra = 'ADVANCE_AUTO_PARTS_STUARTS_DRA',
  AdvanceAutoPartsWaynesboro = 'ADVANCE_AUTO_PARTS_WAYNESBORO',
  AdvancedDrainage = 'ADVANCED_DRAINAGE',
  AgmarkIntermodalSystems = 'AGMARK_INTERMODAL_SYSTEMS',
  AircoIndustrialGases = 'AIRCO_INDUSTRIAL_GASES',
  AirLandRealEstate = 'AIR_LAND_REAL_ESTATE',
  AJDevelopmentAndExcavating = 'A_J_DEVELOPMENT_AND_EXCAVATING',
  Aldi = 'ALDI',
  AllansonLdPropertyManagemen = 'ALLANSON_LD_PROPERTY_MANAGEMEN',
  AllenYohoElectric = 'ALLEN_YOHO_ELECTRIC',
  AlliedCashAdvance = 'ALLIED_CASH_ADVANCE',
  AlliedExterminatingCoInc = 'ALLIED_EXTERMINATING_CO_INC',
  AlliedHomeMortgage = 'ALLIED_HOME_MORTGAGE',
  AlliedReadyMix = 'ALLIED_READY_MIX',
  AlsCab = 'ALS_CAB',
  AmericanFibersYard = 'AMERICAN_FIBERS_YARD',
  AmericanHardwoodIndustries = 'AMERICAN_HARDWOOD_INDUSTRIES',
  AmericanOfVirginia = 'AMERICAN_OF_VIRGINIA',
  AmericanRealEstate = 'AMERICAN_REAL_ESTATE',
  AmocoWaynesboro = 'AMOCO_WAYNESBORO',
  AnchorPharmacy = 'ANCHOR_PHARMACY',
  AnytimeFitnessStaunton = 'ANYTIME_FITNESS_STAUNTON',
  AnytimeFitnessWaynesboro = 'ANYTIME_FITNESS_WAYNESBORO',
  ApplebeesStaunton = 'APPLEBEES_STAUNTON',
  ApplebeesWaynesboro = 'APPLEBEES_WAYNESBORO',
  ArbysStaunton = 'ARBYS_STAUNTON',
  ArbysStuartsDraft = 'ARBYS_STUARTS_DRAFT',
  ArbysWaynesboro = 'ARBYS_WAYNESBORO',
  AreaWideProtective = 'AREA_WIDE_PROTECTIVE',
  ArehartAndAssociates = 'AREHART_AND_ASSOCIATES',
  AshleyHomeFurniture = 'ASHLEY_HOME_FURNITURE',
  AsplundhTreeExpertCo = 'ASPLUNDH_TREE_EXPERT_CO',
  AssociatedPhysicians = 'ASSOCIATED_PHYSICIANS',
  AstraZeneca = 'ASTRA_ZENECA',
  AtkinsAutomotiveCorp = 'ATKINS_AUTOMOTIVE_CORP',
  AtkinsAutomotiveWaynesboro = 'ATKINS_AUTOMOTIVE_WAYNESBORO',
  AtlanticUnionBankStaAugus = 'ATLANTIC_UNION_BANK_STA_AUGUS',
  AtlanticUnionBankStaBever = 'ATLANTIC_UNION_BANK_STA_BEVER',
  AtlanticUnionBankStaJacks = 'ATLANTIC_UNION_BANK_STA_JACKS',
  AtlanticUnionBankStuDraft = 'ATLANTIC_UNION_BANK_STU_DRAFT',
  AtlanticUnionBankVerona = 'ATLANTIC_UNION_BANK_VERONA',
  AtlanticUnionBankWaynesbor = 'ATLANTIC_UNION_BANK_WAYNESBOR',
  AugCountyGovernmentCenter = 'AUG_COUNTY_GOVERNMENT_CENTER',
  AugustaCleanersAndTailors = 'AUGUSTA_CLEANERS_AND_TAILORS',
  AugustaCoOpFarmBureau = 'AUGUSTA_CO_OP_FARM_BUREAU',
  AugustaCorrectionalCenter = 'AUGUSTA_CORRECTIONAL_CENTER',
  AugustaCoSchools = 'AUGUSTA_CO_SCHOOLS',
  AugustaCoServiceAuthority = 'AUGUSTA_CO_SERVICE_AUTHORITY',
  AugustaCoSheriffsDept = 'AUGUSTA_CO_SHERIFFS_DEPT',
  AugustaCountyFireDepartment = 'AUGUSTA_COUNTY_FIRE_DEPARTMENT',
  AugustaExcavatingCo = 'AUGUSTA_EXCAVATING_CO',
  AugustaExpoland = 'AUGUSTA_EXPOLAND',
  AugustaFarmBureauInsCo = 'AUGUSTA_FARM_BUREAU_INS_CO',
  AugustaGlassAndMirror = 'AUGUSTA_GLASS_AND_MIRROR',
  AugustaHealth = 'AUGUSTA_HEALTH',
  AugustaHealthcareForWomen = 'AUGUSTA_HEALTHCARE_FOR_WOMEN',
  AugustaLumberAndSupplyCo = 'AUGUSTA_LUMBER_AND_SUPPLY_CO',
  AugustaLumberCoWaynesboro = 'AUGUSTA_LUMBER_CO_WAYNESBORO',
  AugustaMutualInsuranceCo = 'AUGUSTA_MUTUAL_INSURANCE_CO',
  AugustaNursingAndRehabCtr = 'AUGUSTA_NURSING_AND_REHAB_CTR',
  AugustaOrthopedicSurgery = 'AUGUSTA_ORTHOPEDIC_SURGERY',
  AugustaPediatrics = 'AUGUSTA_PEDIATRICS',
  AugustaPetroleumSouthernSts = 'AUGUSTA_PETROLEUM_SOUTHERN_STS',
  AugustaPsychologicalAssoc = 'AUGUSTA_PSYCHOLOGICAL_ASSOC',
  AugustaStauntonHealthDept = 'AUGUSTA_STAUNTON_HEALTH_DEPT',
  AugustaSteelCorporation = 'AUGUSTA_STEEL_CORPORATION',
  AugustaUtilities = 'AUGUSTA_UTILITIES',
  AutozoneStaunton = 'AUTOZONE_STAUNTON',
  AutozoneWaynesboro = 'AUTOZONE_WAYNESBORO',
  Avintiv = 'AVINTIV',
  AWBuildingSupply = 'A_W_BUILDING_SUPPLY',
  BaberEnterprises = 'BABER_ENTERPRISES',
  BakerBrothersInc = 'BAKER_BROTHERS_INC',
  BallAdvancedTechnology = 'BALL_ADVANCED_TECHNOLOGY',
  BankOfAmericaStaunton = 'BANK_OF_AMERICA_STAUNTON',
  BankOfAmericaWaynesboro = 'BANK_OF_AMERICA_WAYNESBORO',
  BantaCorp = 'BANTA_CORP',
  BargerInsurance = 'BARGER_INSURANCE',
  BartlettTreeExperts = 'BARTLETT_TREE_EXPERTS',
  BasicCityLuncheonette = 'BASIC_CITY_LUNCHEONETTE',
  BathAndBodyWorksStaunton = 'BATH_AND_BODY_WORKS_STAUNTON',
  BathCountySchoolBoard = 'BATH_COUNTY_SCHOOL_BOARD',
  BaugherChevroletBuickInc = 'BAUGHER_CHEVROLET_BUICK_INC',
  BbtBankChurchvilleBranch = 'BBT_BANK_CHURCHVILLE_BRANCH',
  BbtCentralAveBranch = 'BBT_CENTRAL_AVE_BRANCH',
  BbtHopemanPkwyBranch = 'BBT_HOPEMAN_PKWY_BRANCH',
  BbtInsuranceServicesWayne = 'BBT_INSURANCE_SERVICES_WAYNE',
  BbtStuartsDraftBranch = 'BBT_STUARTS_DRAFT_BRANCH',
  BedBathBeyondHarrisonburg = 'BED_BATH_BEYOND_HARRISONBURG',
  BedBathBeyondWaynesboro = 'BED_BATH_BEYOND_WAYNESBORO',
  BelkStauntonMall = 'BELK_STAUNTON_MALL',
  BerrangPontiacCadillac = 'BERRANG_PONTIAC_CADILLAC',
  BerryPlastics = 'BERRY_PLASTICS',
  BestBuys = 'BEST_BUYS',
  BestWestern = 'BEST_WESTERN',
  BigLots1417Waynesboro = 'BIG_LOTS_1417_WAYNESBORO',
  BigLots276Staunton = 'BIG_LOTS_276_STAUNTON',
  BigOTreeService = 'BIG_O_TREE_SERVICE',
  BloomakerUsa = 'BLOOMAKER_USA',
  BlueMountainBrewery = 'BLUE_MOUNTAIN_BREWERY',
  BlueRidgeAreaFoodBank = 'BLUE_RIDGE_AREA_FOOD_BANK',
  BlueRidgeBeverageCompany = 'BLUE_RIDGE_BEVERAGE_COMPANY',
  BlueRidgeBuildersSupply = 'BLUE_RIDGE_BUILDERS_SUPPLY',
  BlueRidgeCommunityCollege = 'BLUE_RIDGE_COMMUNITY_COLLEGE',
  BlueRidgeLumberCo = 'BLUE_RIDGE_LUMBER_CO',
  BlueRidgePathologist = 'BLUE_RIDGE_PATHOLOGIST',
  BlueRidgePediatrics = 'BLUE_RIDGE_PEDIATRICS',
  BlueRidgeRadiologist = 'BLUE_RIDGE_RADIOLOGIST',
  BlueRidgeSheetMetalCoInc = 'BLUE_RIDGE_SHEET_METAL_CO_INC',
  BoarsHeadInn = 'BOARS_HEAD_INN',
  BojanglesStaunton = 'BOJANGLES_STAUNTON',
  BooksAMillion = 'BOOKS_A_MILLION',
  BotkinPlumbingAndHeating = 'BOTKIN_PLUMBING_AND_HEATING',
  Boyers72Degrees = 'BOYERS_72_DEGREES',
  BoyScoutsOfAmerica = 'BOY_SCOUTS_OF_AMERICA',
  BradleyInsuranceServices = 'BRADLEY_INSURANCE_SERVICES',
  BranchHighwaysInc = 'BRANCH_HIGHWAYS_INC',
  BridgewaterCollege = 'BRIDGEWATER_COLLEGE',
  BridgewaterHomeInc = 'BRIDGEWATER_HOME_INC',
  BrightviewAtBaldwinPark = 'BRIGHTVIEW_AT_BALDWIN_PARK',
  BrookdaleSeniorLiving = 'BROOKDALE_SENIOR_LIVING',
  BrownExcavating = 'BROWN_EXCAVATING',
  BudgetInnStaunton = 'BUDGET_INN_STAUNTON',
  BudgetInnWaynesboro = 'BUDGET_INN_WAYNESBORO',
  BuenaVistaPublicSchools = 'BUENA_VISTA_PUBLIC_SCHOOLS',
  BuffaloWildWings = 'BUFFALO_WILD_WINGS',
  BurgerKingGreenvilleAveSta = 'BURGER_KING_GREENVILLE_AVE_STA',
  BurgerKingRichmondAveStaun = 'BURGER_KING_RICHMOND_AVE_STAUN',
  BurgerKingVerona = 'BURGER_KING_VERONA',
  BurgerKingWaynesboro = 'BURGER_KING_WAYNESBORO',
  BurgersShakesAndThings = 'BURGERS_SHAKES_AND_THINGS',
  BurrisRefrigeration = 'BURRIS_REFRIGERATION',
  ByersStreetBistro = 'BYERS_STREET_BISTRO',
  CadenceCorporation = 'CADENCE_CORPORATION',
  CampbellsSepticTankSvs = 'CAMPBELLS_SEPTIC_TANK_SVS',
  CAndCWeldingCo = 'C_AND_C_WELDING_CO',
  CanteenVendingServices = 'CANTEEN_VENDING_SERVICES',
  CardinalHouse = 'CARDINAL_HOUSE',
  CareAdvantage = 'CARE_ADVANTAGE',
  CargillInc = 'CARGILL_INC',
  CarrsTireService = 'CARRS_TIRE_SERVICE',
  CarterMachineryCoInc = 'CARTER_MACHINERY_CO_INC',
  CatoFashions = 'CATO_FASHIONS',
  CentralSecurity = 'CENTRAL_SECURITY',
  CentralTireCorp = 'CENTRAL_TIRE_CORP',
  CentralVaLawnGardenCenter = 'CENTRAL_VA_LAWN_GARDEN_CENTER',
  CentralVaRentJeffersonHwy = 'CENTRAL_VA_RENT_JEFFERSON_HWY',
  CentralVaRentWMainSt = 'CENTRAL_VA_RENT_W_MAIN_ST',
  CentralVirginiaRentalFisher = 'CENTRAL_VIRGINIA_RENTAL_FISHER',
  CentralVirginiaRentalStaunt = 'CENTRAL_VIRGINIA_RENTAL_STAUNT',
  CerroFabrication = 'CERRO_FABRICATION',
  CharlieObaughWaynesboro = 'CHARLIE_OBAUGH_WAYNESBORO',
  ChesterFarms = 'CHESTER_FARMS',
  ChevrontsSupplyCo = 'CHEVRONTS_SUPPLY_CO',
  ChickFilAStaunton = 'CHICK_FIL_A_STAUNTON',
  ChickFilAWaynesboro = 'CHICK_FIL_A_WAYNESBORO',
  ChilisGrillAndBar = 'CHILIS_GRILL_AND_BAR',
  Cintas = 'CINTAS',
  CityNationalBankRaphine = 'CITY_NATIONAL_BANK_RAPHINE',
  CityNationalBankStaCentral = 'CITY_NATIONAL_BANK_STA_CENTRAL',
  CityNationalBankStaCommWa = 'CITY_NATIONAL_BANK_STA_COMM_WA',
  CityNationalBankStuartsDra = 'CITY_NATIONAL_BANK_STUARTS_DRA',
  CityNationalBankVerona = 'CITY_NATIONAL_BANK_VERONA',
  CityNationalBankWaynesboro = 'CITY_NATIONAL_BANK_WAYNESBORO',
  ClaytonHomesHarrisonburg = 'CLAYTON_HOMES_HARRISONBURG',
  ClaytonHomesStuartsDraft = 'CLAYTON_HOMES_STUARTS_DRAFT',
  CocaColaBottlingCompany = 'COCA_COLA_BOTTLING_COMPANY',
  ComcastStaunton = 'COMCAST_STAUNTON',
  Comdial = 'COMDIAL',
  ComfortInn = 'COMFORT_INN',
  CommonwealthCenterChildren = 'COMMONWEALTH_CENTER_CHILDREN',
  CommonwealthGasServicesInc = 'COMMONWEALTH_GAS_SERVICES_INC',
  CommunityBank = 'COMMUNITY_BANK',
  CommunityFellowshipChurch = 'COMMUNITY_FELLOWSHIP_CHURCH',
  CommunityLivingServices = 'COMMUNITY_LIVING_SERVICES',
  ComputerConcepts = 'COMPUTER_CONCEPTS',
  ComsonicsInc = 'COMSONICS_INC',
  ConcourseCafeRestaurant = 'CONCOURSE_CAFE_RESTAURANT',
  ConWaySouthernExpress = 'CON_WAY_SOUTHERN_EXPRESS',
  CookOutWayneWMainSt = 'COOK_OUT_WAYNE_W_MAIN_ST',
  Coors = 'COORS',
  CornerstoneJanitorial = 'CORNERSTONE_JANITORIAL',
  Costco = 'COSTCO',
  CountryCookinRestaurant = 'COUNTRY_COOKIN_RESTAURANT',
  CountyOfAlbemarle = 'COUNTY_OF_ALBEMARLE',
  CoxConstruction = 'COX_CONSTRUCTION',
  CrackerBarrell = 'CRACKER_BARRELL',
  CrackerBarrellWaynesboro = 'CRACKER_BARRELL_WAYNESBORO',
  CrosBCrestFarms = 'CROS_B_CREST_FARMS',
  CrosbyTruckingCompany = 'CROSBY_TRUCKING_COMPANY',
  CrozetInsurance = 'CROZET_INSURANCE',
  CvsBarterbrookRd = 'CVS_BARTERBROOK_RD',
  CvsBroadStWaynesboro = 'CVS_BROAD_ST_WAYNESBORO',
  CvsChurchvilleAveStaunton = 'CVS_CHURCHVILLE_AVE_STAUNTON',
  CvsMainStWaynesboro = 'CVS_MAIN_ST_WAYNESBORO',
  Daikin = 'DAIKIN',
  DairyQueenStuartsDraft = 'DAIRY_QUEEN_STUARTS_DRAFT',
  DairyQueenVerona = 'DAIRY_QUEEN_VERONA',
  DanoneNorthAmerica = 'DANONE_NORTH_AMERICA',
  DanonewaveFoods = 'DANONEWAVE_FOODS',
  DavesHeatingAndCooling = 'DAVES_HEATING_AND_COOLING',
  DaviCommunications = 'DAVI_COMMUNICATIONS',
  DaysInnStaunton = 'DAYS_INN_STAUNTON',
  DaysInnWaynesboro = 'DAYS_INN_WAYNESBORO',
  DeanSteelErectionCoInc = 'DEAN_STEEL_ERECTION_CO_INC',
  DegeschAmericaInc = 'DEGESCH_AMERICA_INC',
  DelmarsBodyShop = 'DELMARS_BODY_SHOP',
  DepartmentOfAgriculture = 'DEPARTMENT_OF_AGRICULTURE',
  DepotGrille = 'DEPOT_GRILLE',
  DevilsBackboneBrewCoLexing = 'DEVILS_BACKBONE_BREW_CO_LEXING',
  DevilsBackboneBrewCoRosela = 'DEVILS_BACKBONE_BREW_CO_ROSELA',
  DillonAcContractor = 'DILLON_AC_CONTRACTOR',
  Disabled = 'DISABLED',
  DiversifiedCommunications = 'DIVERSIFIED_COMMUNICATIONS',
  DixieGasAndOil = 'DIXIE_GAS_AND_OIL',
  DodsonBroExterminatingCo = 'DODSON_BRO_EXTERMINATING_CO',
  DollarTreeStaunton = 'DOLLAR_TREE_STAUNTON',
  DollarTreeWaynesboro = 'DOLLAR_TREE_WAYNESBORO',
  DollerGeneralCrimora = 'DOLLER_GENERAL_CRIMORA',
  DollerGeneralGreenville = 'DOLLER_GENERAL_GREENVILLE',
  DollerGeneralStaunton = 'DOLLER_GENERAL_STAUNTON',
  DollerGeneralStauntonGreenv = 'DOLLER_GENERAL_STAUNTON_GREENV',
  DollerGeneralStauntonWBeve = 'DOLLER_GENERAL_STAUNTON_W_BEVE',
  DollerGeneralVerona = 'DOLLER_GENERAL_VERONA',
  DollerGeneralWayneBroadSt = 'DOLLER_GENERAL_WAYNE_BROAD_ST',
  DollerGeneralWayneHopemanP = 'DOLLER_GENERAL_WAYNE_HOPEMAN_P',
  DollTreeLeeJacksonStaunton = 'DOLL_TREE_LEE_JACKSON_STAUNTON',
  DollTreeWMainWaynesboro = 'DOLL_TREE_W_MAIN_WAYNESBORO',
  DominionOutdoors = 'DOMINION_OUTDOORS',
  DominionPower = 'DOMINION_POWER',
  DominosPizzaStaunton = 'DOMINOS_PIZZA_STAUNTON',
  DominosPizzaStuartsDraft = 'DOMINOS_PIZZA_STUARTS_DRAFT',
  DominosPizzaWaynesboro = 'DOMINOS_PIZZA_WAYNESBORO',
  DrakeFr = 'DRAKE_FR',
  DriversBrothersNurseries = 'DRIVERS_BROTHERS_NURSERIES',
  DrPepperBottlingCompany = 'DR_PEPPER_BOTTLING_COMPANY',
  DscLogistics = 'DSC_LOGISTICS',
  DunhamBush = 'DUNHAM_BUSH',
  DupCreditUnionAugStBranch = 'DUP_CREDIT_UNION_AUG_ST_BRANCH',
  DupCreditUnionCommWayBrnc = 'DUP_CREDIT_UNION_COMM_WAY_BRNC',
  DupontCreditUnionDupontBlv = 'DUPONT_CREDIT_UNION_DUPONT_BLV',
  DupontCreditUnionEBroadSt = 'DUPONT_CREDIT_UNION_E_BROAD_ST',
  DupontCreditUnionLucyLane = 'DUPONT_CREDIT_UNION_LUCY_LANE',
  DupontCreditUnionWMainSt = 'DUPONT_CREDIT_UNION_W_MAIN_ST',
  DynamicAviation = 'DYNAMIC_AVIATION',
  EAndEPlumbing = 'E_AND_E_PLUMBING',
  EaversBrothers = 'EAVERS_BROTHERS',
  EaversGuyCExcavating = 'EAVERS_GUY_C_EXCAVATING',
  EaversTireProFishersville = 'EAVERS_TIRE_PRO_FISHERSVILLE',
  EaversTireProStuartsDraft = 'EAVERS_TIRE_PRO_STUARTS_DRAFT',
  EcholsBrothers = 'ECHOLS_BROTHERS',
  EconoLodge = 'ECONO_LODGE',
  EducationAndTrainingCorp = 'EDUCATION_AND_TRAINING_CORP',
  EdwardsTrucking = 'EDWARDS_TRUCKING',
  EfcoCorp = 'EFCO_CORP',
  EilandJohnDDistributors = 'EILAND_JOHN_D_DISTRIBUTORS',
  Electrolux = 'ELECTROLUX',
  ElliottChevrolet = 'ELLIOTT_CHEVROLET',
  ElPuertoStaunton = 'EL_PUERTO_STAUNTON',
  ElPuertoWaynesboro = 'EL_PUERTO_WAYNESBORO',
  Emergicare = 'EMERGICARE',
  EnvoyHealthcareWasRuxton = 'ENVOY_HEALTHCARE_WAS_RUXTON',
  ErieInsurance = 'ERIE_INSURANCE',
  EstesExpressLines = 'ESTES_EXPRESS_LINES',
  EtterFuneralHome = 'ETTER_FUNERAL_HOME',
  ExpressPersonnelServicees = 'EXPRESS_PERSONNEL_SERVICEES',
  EyeoneCharlottesville = 'EYEONE_CHARLOTTESVILLE',
  EyeoneCovington = 'EYEONE_COVINGTON',
  EyeoneFishersville = 'EYEONE_FISHERSVILLE',
  EyeoneStauntonCommRoad = 'EYEONE_STAUNTON_COMM_ROAD',
  EyeoneStauntonNAugustaSt = 'EYEONE_STAUNTON_N_AUGUSTA_ST',
  EyeoneWaynesboro = 'EYEONE_WAYNESBORO',
  FactoryAntiqueMall = 'FACTORY_ANTIQUE_MALL',
  FairfieldInn = 'FAIRFIELD_INN',
  FairfieldSkanskaInc = 'FAIRFIELD_SKANSKA_INC',
  FamilyBarberAndBeautyShop = 'FAMILY_BARBER_AND_BEAUTY_SHOP',
  FamilyDollarStoreStaunton = 'FAMILY_DOLLAR_STORE_STAUNTON',
  FamilyDollarStuartsDraft = 'FAMILY_DOLLAR_STUARTS_DRAFT',
  FamilyDollarWaynesboro = 'FAMILY_DOLLAR_WAYNESBORO',
  FashionGallery = 'FASHION_GALLERY',
  FaulknerConstructionCompany = 'FAULKNER_CONSTRUCTION_COMPANY',
  FederatedAutoPartsStaunton = 'FEDERATED_AUTO_PARTS_STAUNTON',
  FedExFishersville = 'FED_EX_FISHERSVILLE',
  FencoInc = 'FENCO_INC',
  FergusonMetalFabrication = 'FERGUSON_METAL_FABRICATION',
  FirehouseSubs = 'FIREHOUSE_SUBS',
  FirstBankAndTrustStaunton = 'FIRST_BANK_AND_TRUST_STAUNTON',
  FirstBankAndTrustVerona = 'FIRST_BANK_AND_TRUST_VERONA',
  FirstBankAndTrustWaynesbor = 'FIRST_BANK_AND_TRUST_WAYNESBOR',
  FirstCitizenBankBridgewater = 'FIRST_CITIZEN_BANK_BRIDGEWATER',
  FirstCitizenBankGrottoes = 'FIRST_CITIZEN_BANK_GROTTOES',
  FirstCitizenBankVerona = 'FIRST_CITIZEN_BANK_VERONA',
  FirstCitizenBankWeyersCave = 'FIRST_CITIZEN_BANK_WEYERS_CAVE',
  FirstCitizensBankHburg = 'FIRST_CITIZENS_BANK_HBURG',
  FirstCitizensBankWboro = 'FIRST_CITIZENS_BANK_WBORO',
  FirstUnionBankStaunton = 'FIRST_UNION_BANK_STAUNTON',
  FirstUnionBankVerona = 'FIRST_UNION_BANK_VERONA',
  FishburneMilitarySchool = 'FISHBURNE_MILITARY_SCHOOL',
  FisherAutoPartsChurchville = 'FISHER_AUTO_PARTS_CHURCHVILLE',
  FisherAutoPartsCrozet = 'FISHER_AUTO_PARTS_CROZET',
  FisherAutoPartsGreenville = 'FISHER_AUTO_PARTS_GREENVILLE',
  FisherAutoPartsGrottoes = 'FISHER_AUTO_PARTS_GROTTOES',
  FisherAutoPartsMorrisMill = 'FISHER_AUTO_PARTS_MORRIS_MILL',
  FisherAutoPartsNellysford = 'FISHER_AUTO_PARTS_NELLYSFORD',
  FisherAutoPartsStatlerBlvd = 'FISHER_AUTO_PARTS_STATLER_BLVD',
  FisherAutoPartsStuartsDraf = 'FISHER_AUTO_PARTS_STUARTS_DRAF',
  FisherAutoPartsVerona = 'FISHER_AUTO_PARTS_VERONA',
  FisherAutoPartsWaynesboro = 'FISHER_AUTO_PARTS_WAYNESBORO',
  FishersvillePostOffice = 'FISHERSVILLE_POST_OFFICE',
  FitzgeraldTireServices = 'FITZGERALD_TIRE_SERVICES',
  FlintInkCorp = 'FLINT_INK_CORP',
  FoodLionFishersville = 'FOOD_LION_FISHERSVILLE',
  FoodLionGrottoes = 'FOOD_LION_GROTTOES',
  FoodLionHopemanParkway = 'FOOD_LION_HOPEMAN_PARKWAY',
  FoodLionNCoalterStreet = 'FOOD_LION_N_COALTER_STREET',
  FoodLionOrchardHillCenter = 'FOOD_LION_ORCHARD_HILL_CENTER',
  FoodLionStuartsDraft = 'FOOD_LION_STUARTS_DRAFT',
  FoodLionVerona = 'FOOD_LION_VERONA',
  FoodLionWBeverlyStreet = 'FOOD_LION_W_BEVERLY_STREET',
  FriendshipIndustries = 'FRIENDSHIP_INDUSTRIES',
  FritoLay = 'FRITO_LAY',
  FrontierCommunityBank = 'FRONTIER_COMMUNITY_BANK',
  FrontierCultureMuseum = 'FRONTIER_CULTURE_MUSEUM',
  GatewayEnterprises = 'GATEWAY_ENTERPRISES',
  GarrettCountyBoardOfEducation = 'GARRETT_COUNTY_BOARD_OF_EDUCATION',
  GarrettCountyGovernment = 'GARRETT_COUNTY_GOVERNMENT',
  GeFanuc = 'GE_FANUC',
  GoldenCorral = 'GOLDEN_CORRAL',
  GoodwillStaunton = 'GOODWILL_STAUNTON',
  GoodwillVerona = 'GOODWILL_VERONA',
  GoodwillWaynesboro = 'GOODWILL_WAYNESBORO',
  GoodysFamilyClothingInc = 'GOODYS_FAMILY_CLOTHING_INC',
  GrahamPackaging = 'GRAHAM_PACKAGING',
  GrandPianoFurnitureStaunton = 'GRAND_PIANO_FURNITURE_STAUNTON',
  GrandPianoFurnitureWaynesb = 'GRAND_PIANO_FURNITURE_WAYNESB',
  GraphicPackaging = 'GRAPHIC_PACKAGING',
  GreenvilleColdSprings = 'GREENVILLE_COLD_SPRINGS',
  HairCutteryWayneLucyLane = 'HAIR_CUTTERY_WAYNE_LUCY_LANE',
  HairCutteryWayneTownCenter = 'HAIR_CUTTERY_WAYNE_TOWN_CENTER',
  HajocaCorporation = 'HAJOCA_CORPORATION',
  HarbourFreight = 'HARBOUR_FREIGHT',
  HardeesNCentralAvenue = 'HARDEES_N_CENTRAL_AVENUE',
  HardeesVerona = 'HARDEES_VERONA',
  HardeesWindmillSquare = 'HARDEES_WINDMILL_SQUARE',
  HardeesWMainStWaynesboro = 'HARDEES_W_MAIN_ST_WAYNESBORO',
  HarrisonburgCitySchools = 'HARRISONBURG_CITY_SCHOOLS',
  HarrisonburgNissanInc = 'HARRISONBURG_NISSAN_INC',
  HathawayPaperCompany = 'HATHAWAY_PAPER_COMPANY',
  HawpeDouglasCpa = 'HAWPE_DOUGLAS_CPA',
  HdtExpentionarySystems = 'HDT_EXPENTIONARY_SYSTEMS',
  HenryFuneralHomeInc = 'HENRY_FUNERAL_HOME_INC',
  HersheyChocolate = 'HERSHEY_CHOCOLATE',
  HersheyTireInc = 'HERSHEY_TIRE_INC',
  HillsideResidentialLiving = 'HILLSIDE_RESIDENTIAL_LIVING',
  HiTechSalon = 'HI_TECH_SALON',
  HolidayInnConfCenter = 'HOLIDAY_INN_CONF_CENTER',
  HolidayInnExpressWboro = 'HOLIDAY_INN_EXPRESS_WBORO',
  HollistersInc = 'HOLLISTERS_INC',
  HomeAwayFromHomeDogGroomi = 'HOME_AWAY_FROM_HOME_DOG_GROOMI',
  HomeDepot4645Hburg = 'HOME_DEPOT_4645_HBURG',
  HomeInsteadSeniorCare = 'HOME_INSTEAD_SENIOR_CARE',
  HomeIvCare = 'HOME_IV_CARE',
  HomesteadMaterialHandling = 'HOMESTEAD_MATERIAL_HANDLING',
  HomesteadResort = 'HOMESTEAD_RESORT',
  HometownGrillAndBuffet = 'HOMETOWN_GRILL_AND_BUFFET',
  HospiceOfPiedmond = 'HOSPICE_OF_PIEDMOND',
  HouffTransfer = 'HOUFF_TRANSFER',
  HumphriesPressInc = 'HUMPHRIES_PRESS_INC',
  IndependentTermiteAndPest = 'INDEPENDENT_TERMITE_AND_PEST',
  IndustrialFabricatorsOfVa = 'INDUSTRIAL_FABRICATORS_OF_VA',
  IndustrialMachineWorksInc = 'INDUSTRIAL_MACHINE_WORKS_INC',
  InglesideHotelAndMotel = 'INGLESIDE_HOTEL_AND_MOTEL',
  InnAtAfton = 'INN_AT_AFTON',
  Innkeeper = 'INNKEEPER',
  InnovativeRefrigerationSyste = 'INNOVATIVE_REFRIGERATION_SYSTE',
  InterimHealthCareOfFishers = 'INTERIM_HEALTH_CARE_OF_FISHERS',
  InterimHealthcareOfVerona = 'INTERIM_HEALTHCARE_OF_VERONA',
  InterstateMufflersInc = 'INTERSTATE_MUFFLERS_INC',
  IntrepidHomeHealth = 'INTREPID_HOME_HEALTH',
  JamesMadisonUniversity = 'JAMES_MADISON_UNIVERSITY',
  JamesRiverEquipment = 'JAMES_RIVER_EQUIPMENT',
  JBHuntTransportServices = 'J_B_HUNT_TRANSPORT_SERVICES',
  JenkinsSecurityServicesInc = 'JENKINS_SECURITY_SERVICES_INC',
  JgmCoach = 'JGM_COACH',
  JiffyLube = 'JIFFY_LUBE',
  JimSneadFord = 'JIM_SNEAD_FORD',
  KathysRestaurantStaunton = 'KATHYS_RESTAURANT_STAUNTON',
  KdhNursingAndRehabCenter = 'KDH_NURSING_AND_REHAB_CENTER',
  KdpInc = 'KDP_INC',
  KenBridgeCorp = 'KEN_BRIDGE_CORP',
  KentuckyFriedChicken = 'KENTUCKY_FRIED_CHICKEN',
  KisamoreLumber = 'KISAMORE_LUMBER',
  KitchinCookdPotatoChipCo = 'KITCHIN_COOKD_POTATO_CHIP_CO',
  KlannInc = 'KLANN_INC',
  KlineMayRealty = 'KLINE_MAY_REALTY',
  KlinesDairyBar = 'KLINES_DAIRY_BAR',
  Kmart = 'KMART',
  KnoppEnterpriseInc = 'KNOPP_ENTERPRISE_INC',
  Kohls = 'KOHLS',
  KrispyKremeDoughnutCorp = 'KRISPY_KREME_DOUGHNUT_CORP',
  KrogersStaunton = 'KROGERS_STAUNTON',
  KrogersWaynesboro = 'KROGERS_WAYNESBORO',
  LawrenceTransferStorageCo = 'LAWRENCE_TRANSFER_STORAGE_CO',
  LeesHeatingAndCooling = 'LEES_HEATING_AND_COOLING',
  LehighPortlandCementCo = 'LEHIGH_PORTLAND_CEMENT_CO',
  LibertyPointBehavioralHealt = 'LIBERTY_POINT_BEHAVIORAL_HEALT',
  LiphartSteelCompany = 'LIPHART_STEEL_COMPANY',
  LittleCaesarsPizzaStaunton = 'LITTLE_CAESARS_PIZZA_STAUNTON',
  LittleCaesarsPizzaWaynesbor = 'LITTLE_CAESARS_PIZZA_WAYNESBOR',
  LittleCaesarsWaynesboro = 'LITTLE_CAESARS_WAYNESBORO',
  LittleMariasPizzaAndSubs = 'LITTLE_MARIAS_PIZZA_AND_SUBS',
  Lofton = 'LOFTON',
  LongJohnSilversStaunton = 'LONG_JOHN_SILVERS_STAUNTON',
  LongJohnSilversWaynesboro = 'LONG_JOHN_SILVERS_WAYNESBORO',
  LowesStaunton = 'LOWES_STAUNTON',
  LowesWaynesboro = 'LOWES_WAYNESBORO',
  Loyalton = 'LOYALTON',
  LuckQuarriesInc = 'LUCK_QUARRIES_INC',
  LumosWayneBroadSt = 'LUMOS_WAYNE_BROAD_ST',
  LumosWayneMainSt = 'LUMOS_WAYNE_MAIN_ST',
  Mancon = 'MANCON',
  ManpowerStauntonOffice = 'MANPOWER_STAUNTON_OFFICE',
  MarchInc = 'MARCH_INC',
  MariasPizza = 'MARIAS_PIZZA',
  MarinerFinance = 'MARINER_FINANCE',
  MarshallsInc = 'MARSHALLS_INC',
  MarthaJeffersonHospital = 'MARTHA_JEFFERSON_HOSPITAL',
  Martins6226Staunton = 'MARTINS_6226_STAUNTON',
  Martins6285Waynesboro = 'MARTINS_6285_WAYNESBORO',
  Martins6285WaynesboroVa = 'MARTINS_6285_WAYNESBORO_VA',
  Martins6424Harrisonburg = 'MARTINS_6424_HARRISONBURG',
  Martins6426StauntonVa = 'MARTINS_6426_STAUNTON_VA',
  MaryBaldwinUniversity = 'MARY_BALDWIN_UNIVERSITY',
  MassakiJapeneseSteakhouse = 'MASSAKI_JAPENESE_STEAKHOUSE',
  MassanuttenVacationsLlc = 'MASSANUTTEN_VACATIONS_LLC',
  MassanuttenVocationalCenter = 'MASSANUTTEN_VOCATIONAL_CENTER',
  McalistersDeli = 'MCALISTERS_DELI',
  McclungDesignwritePrinting = 'MCCLUNG_DESIGNWRITE_PRINTING',
  McdonaldsFishersville = 'MCDONALDS_FISHERSVILLE',
  McdonaldsStaunCochranParkwa = 'MCDONALDS_STAUN_COCHRAN_PARKWA',
  McdonaldsStaunGreenville = 'MCDONALDS_STAUN_GREENVILLE',
  McdonaldsStaunJeffersonHwy = 'MCDONALDS_STAUN_JEFFERSON_HWY',
  McdonaldsVerona = 'MCDONALDS_VERONA',
  McdonaldsWaynesboro1501 = 'MCDONALDS_WAYNESBORO_1501',
  McdonaldsWaynesboro720 = 'MCDONALDS_WAYNESBORO_720',
  McdonoughDodgeInc = 'MCDONOUGH_DODGE_INC',
  McdonoughToyota = 'MCDONOUGH_TOYOTA',
  MckeesBaking = 'MCKEES_BAKING',
  McquayAafInc = 'MCQUAY_AAF_INC',
  MeadeTrucking = 'MEADE_TRUCKING',
  Meadwestvaco = 'MEADWESTVACO',
  MedExpress = 'MED_EXPRESS',
  MedicalCenterPharmacy = 'MEDICAL_CENTER_PHARMACY',
  MerchantTireAndAutoStaunto = 'MERCHANT_TIRE_AND_AUTO_STAUNTO',
  Merck = 'MERCK',
  MesserLandscapeIncNursery = 'MESSER_LANDSCAPE_INC_NURSERY',
  MetFabInternational = 'MET_FAB_INTERNATIONAL',
  MgIndustriesGasProducts = 'MG_INDUSTRIES_GAS_PRODUCTS',
  MichaelsArtsAndCrafts = 'MICHAELS_ARTS_AND_CRAFTS',
  MiddleRiverRegionalJail = 'MIDDLE_RIVER_REGIONAL_JAIL',
  MillmontGreenhouse = 'MILLMONT_GREENHOUSE',
  MillStreetGrill = 'MILL_STREET_GRILL',
  ModineManufacturingCo = 'MODINE_MANUFACTURING_CO',
  MoffettPaving = 'MOFFETT_PAVING',
  Mohawk = 'MOHAWK',
  MohawkWaynesboroDivision = 'MOHAWK_WAYNESBORO_DIVISION',
  MooreBrothers = 'MOORE_BROTHERS',
  MooreBusinessFormsInc = 'MOORE_BUSINESS_FORMS_INC',
  MooresBuildingSupplies = 'MOORES_BUILDING_SUPPLIES',
  MorningStarFoods = 'MORNING_STAR_FOODS',
  Mundy = 'MUNDY',
  MuntersDeschampTechnologies = 'MUNTERS_DESCHAMP_TECHNOLOGIES',
  MusicTodayCrozet = 'MUSIC_TODAY_CROZET',
  MysticIslandTransportation = 'MYSTIC_ISLAND_TRANSPORTATION',
  NationalLinenService = 'NATIONAL_LINEN_SERVICE',
  NelsonCountyPublicSchools = 'NELSON_COUNTY_PUBLIC_SCHOOLS',
  NeumanAluminum = 'NEUMAN_ALUMINUM',
  NewBeginnings = 'NEW_BEGINNINGS',
  NewsVirginian = 'NEWS_VIRGINIAN',
  Nibco = 'NIBCO',
  NielsonConstructionCompany = 'NIELSON_CONSTRUCTION_COMPANY',
  NotEmployed = 'NOT_EMPLOYED',
  OakGroveManor = 'OAK_GROVE_MANOR',
  OakwoodHomes = 'OAKWOOD_HOMES',
  ObaughCharlieStaunton = 'OBAUGH_CHARLIE_STAUNTON',
  ObjectiveIndustries = 'OBJECTIVE_INDUSTRIES',
  OfficeImageSmart = 'OFFICE_IMAGE_SMART',
  OldDominionFreightLine = 'OLD_DOMINION_FREIGHT_LINE',
  OreillyAutoParts = 'OREILLY_AUTO_PARTS',
  OutbackSteakhouseWaynesboro = 'OUTBACK_STEAKHOUSE_WAYNESBORO',
  OverniteTransportation = 'OVERNITE_TRANSPORTATION',
  PackagingCorpHarrisonburg = 'PACKAGING_CORP_HARRISONBURG',
  PackagingServices = 'PACKAGING_SERVICES',
  Pactiv = 'PACTIV',
  PAndDInteriorsInc = 'P_AND_D_INTERIORS_INC',
  PaneraBreadWaynesboro = 'PANERA_BREAD_WAYNESBORO',
  PapaJohnsPizzaStaGreenvill = 'PAPA_JOHNS_PIZZA_STA_GREENVILL',
  PapaJohnsPizzaWayPoplarAv = 'PAPA_JOHNS_PIZZA_WAY_POPLAR_AV',
  PaulObaughFordChrysler = 'PAUL_OBAUGH_FORD_CHRYSLER',
  PDInteriorsInc = 'P_D_INTERIORS_INC',
  PeeblesDeptStore = 'PEEBLES_DEPT_STORE',
  PenneyJCCompanyInc = 'PENNEY_J_C_COMPANY_INC',
  PennyPlate = 'PENNY_PLATE',
  PeoplePlacesInc = 'PEOPLE_PLACES_INC',
  Perdue = 'PERDUE',
  Petsmart = 'PETSMART',
  PetsNPals = 'PETS_N_PALS',
  PilgrimsPrideCorp = 'PILGRIMS_PRIDE_CORP',
  PizzaHutGreenvilleAvenue = 'PIZZA_HUT_GREENVILLE_AVENUE',
  PizzaHutNorthCoalterSt = 'PIZZA_HUT_NORTH_COALTER_ST',
  PizzaHutWaynesboro = 'PIZZA_HUT_WAYNESBORO',
  PlanetFitnessWaynesboro = 'PLANET_FITNESS_WAYNESBORO',
  PleckerConstructionCompany = 'PLECKER_CONSTRUCTION_COMPANY',
  PlygemAlcoaHomeExteriors = 'PLYGEM_ALCOA_HOME_EXTERIORS',
  PoindexterAndSchorschAttorn = 'POINDEXTER_AND_SCHORSCH_ATTORN',
  PpiTimeZeroInc = 'PPI_TIME_ZERO_INC',
  PrecisionFabricatorsInc = 'PRECISION_FABRICATORS_INC',
  ProbationAndParoleDist12 = 'PROBATION_AND_PAROLE_DIST_12',
  ProperityManagement = 'PROPERITY_MANAGEMENT',
  RayCarrTireStaunton = 'RAY_CARR_TIRE_STAUNTON',
  RayCarTireWaynesboro = 'RAY_CAR_TIRE_WAYNESBORO',
  ReadyIce = 'READY_ICE',
  RealEstateIii = 'REAL_ESTATE_III',
  RedLobsterStaunton = 'RED_LOBSTER_STAUNTON',
  RemaxRealtyWaynesboro = 'REMAX_REALTY_WAYNESBORO',
  RemaxStaunton = 'REMAX_STAUNTON',
  ReoDistributionServicesInc = 'REO_DISTRIBUTION_SERVICES_INC',
  Retired = 'RETIRED',
  RexnorCorp = 'REXNOR_CORP',
  RiddlebergerBrothersInc = 'RIDDLEBERGER_BROTHERS_INC',
  RiteAidStauntonNCoalterSt = 'RITE_AID_STAUNTON_N_COALTER_ST',
  RiteAidStauntonWBeverley = 'RITE_AID_STAUNTON_W_BEVERLEY',
  RiteAidStuartsDraft = 'RITE_AID_STUARTS_DRAFT',
  RiteAidVerona = 'RITE_AID_VERONA',
  RiteAidWaynesboro = 'RITE_AID_WAYNESBORO',
  RobertsOxygenCoInc = 'ROBERTS_OXYGEN_CO_INC',
  RockbridgeCountySchools = 'ROCKBRIDGE_COUNTY_SCHOOLS',
  RockbridgeFarmersCoOp = 'ROCKBRIDGE_FARMERS_CO_OP',
  RockinghamCoPublicSchools = 'ROCKINGHAM_CO_PUBLIC_SCHOOLS',
  RockinghamMemorialHospital = 'ROCKINGHAM_MEMORIAL_HOSPITAL',
  RockysGoldAndSilver = 'ROCKYS_GOLD_AND_SILVER',
  RosesWaynesboro = 'ROSES_WAYNESBORO',
  RossDressForLess = 'ROSS_DRESS_FOR_LESS',
  RowesFamilyRestaurant = 'ROWES_FAMILY_RESTAURANT',
  RubyTuesday = 'RUBY_TUESDAY',
  RuleHonda = 'RULE_HONDA',
  RuxtonHealthcare = 'RUXTON_HEALTHCARE',
  SallyBeautyStaunton2947 = 'SALLY_BEAUTY_STAUNTON_2947',
  SallyBeautyWaynesboro3606 = 'SALLY_BEAUTY_WAYNESBORO_3606',
  SAndWHomeAppliances = 'S_AND_W_HOME_APPLIANCES',
  SchewelFurnitureCoStaunton = 'SCHEWEL_FURNITURE_CO_STAUNTON',
  SchewelFurntitureWaynesboro = 'SCHEWEL_FURNTITURE_WAYNESBORO',
  ScottosItalianRestaurant = 'SCOTTOS_ITALIAN_RESTAURANT',
  SelfEmployed = 'SELF_EMPLOYED',
  SentryFoodMartStaunton = 'SENTRY_FOOD_MART_STAUNTON',
  SharpShopper = 'SHARP_SHOPPER',
  SheetzFishersville = 'SHEETZ_FISHERSVILLE',
  SheetzStaunton = 'SHEETZ_STAUNTON',
  SheetzStuartsDraft = 'SHEETZ_STUARTS_DRAFT',
  SheetzWaynesboro = 'SHEETZ_WAYNESBORO',
  ShenandoahNursingHome = 'SHENANDOAH_NURSING_HOME',
  ShenandoahRecycling = 'SHENANDOAH_RECYCLING',
  ShenandoahSharedHospitalSer = 'SHENANDOAH_SHARED_HOSPITAL_SER',
  ShenandoahValleySocialServ = 'SHENANDOAH_VALLEY_SOCIAL_SERV',
  ShenandoahValleySocialServi = 'SHENANDOAH_VALLEY_SOCIAL_SERVI',
  ShenandoahValleySurgical = 'SHENANDOAH_VALLEY_SURGICAL',
  Shentel = 'SHENTEL',
  ShenValleyElctricMtCrawfor = 'SHEN_VALLEY_ELCTRIC_MT_CRAWFOR',
  ShenValleyJuvenileDetenHme = 'SHEN_VALLEY_JUVENILE_DETEN_HME',
  ShenVallOrthoAndSportsMed = 'SHEN_VALL_ORTHO_AND_SPORTS_MED',
  SherwinWilliamsCoStaunton = 'SHERWIN_WILLIAMS_CO_STAUNTON',
  SherwinWilliamsCoWaynesboro = 'SHERWIN_WILLIAMS_CO_WAYNESBORO',
  ShickelCorporation = 'SHICKEL_CORPORATION',
  ShoffnerIndustries = 'SHOFFNER_INDUSTRIES',
  ShortCircuitElectronics = 'SHORT_CIRCUIT_ELECTRONICS',
  ShueyAgency = 'SHUEY_AGENCY',
  SidelinesCafe = 'SIDELINES_CAFE',
  SimmonsRoofing = 'SIMMONS_ROOFING',
  SiteResources = 'SITE_RESOURCES',
  SmartStart = 'SMART_START',
  SmileyTileStaunton = 'SMILEY_TILE_STAUNTON',
  SouthernElectric = 'SOUTHERN_ELECTRIC',
  SouthernStainlessEquipment = 'SOUTHERN_STAINLESS_EQUIPMENT',
  SouthernStates = 'SOUTHERN_STATES',
  SouthRiverComplex = 'SOUTH_RIVER_COMPLEX',
  SouthRiverRestaurant = 'SOUTH_RIVER_RESTAURANT',
  Spca = 'SPCA',
  SpecialtyBladesInc = 'SPECIALTY_BLADES_INC',
  Sprint = 'SPRINT',
  StanleyInsurance = 'STANLEY_INSURANCE',
  StaplesStaunton = 'STAPLES_STAUNTON',
  StarbucksStaunton = 'STARBUCKS_STAUNTON',
  StarbucksWayneRosserAve = 'STARBUCKS_WAYNE_ROSSER_AVE',
  StarbucksWayneTownCntr = 'STARBUCKS_WAYNE_TOWN_CNTR',
  StateFarmInsuranceAgency = 'STATE_FARM_INSURANCE_AGENCY',
  StauntonAugustaJuvenileCour = 'STAUNTON_AUGUSTA_JUVENILE_COUR',
  StauntonCityOf = 'STAUNTON_CITY_OF',
  StauntonCitySchools = 'STAUNTON_CITY_SCHOOLS',
  StauntonCountryClub = 'STAUNTON_COUNTRY_CLUB',
  StauntonDailyNewsLeader = 'STAUNTON_DAILY_NEWS_LEADER',
  StauntonFrozenFood = 'STAUNTON_FROZEN_FOOD',
  StauntonMachineWorks = 'STAUNTON_MACHINE_WORKS',
  StauntonMallFaisonMngmtSvs = 'STAUNTON_MALL_FAISON_MNGMT_SVS',
  StauntonPlumbingAndHeating = 'STAUNTON_PLUMBING_AND_HEATING',
  StauntonPoliceDepartment = 'STAUNTON_POLICE_DEPARTMENT',
  StauntonPostOfficeNAugust = 'STAUNTON_POST_OFFICE_N_AUGUST',
  StauntonRecreationalDept = 'STAUNTON_RECREATIONAL_DEPT',
  StauntonSteamLaundry = 'STAUNTON_STEAM_LAUNDRY',
  StauntonTractor = 'STAUNTON_TRACTOR',
  StauntonVeteransOpClinic = 'STAUNTON_VETERANS_OP_CLINIC',
  StauntonWrecking = 'STAUNTON_WRECKING',
  SteakNShake = 'STEAK_N_SHAKE',
  StellarOne = 'STELLAR_ONE',
  StevenToyota = 'STEVEN_TOYOTA',
  StLukesAssistedCareLiving = 'ST_LUKES_ASSISTED_CARE_LIVING',
  StonewallJacksonHospital = 'STONEWALL_JACKSON_HOSPITAL',
  StonewallJacksonHotel = 'STONEWALL_JACKSON_HOTEL',
  StopIn = 'STOP_IN',
  StuartHall = 'STUART_HALL',
  StuartsDraftChristianHome = 'STUARTS_DRAFT_CHRISTIAN_HOME',
  StuartsDraftFamilyPractice = 'STUARTS_DRAFT_FAMILY_PRACTICE',
  SubwayGreenvilleAvenue = 'SUBWAY_GREENVILLE_AVENUE',
  SummitSquare = 'SUMMIT_SQUARE',
  SunlitePlastics = 'SUNLITE_PLASTICS',
  SunspotsStudios = 'SUNSPOTS_STUDIOS',
  SuntrustBeverleyStBranch = 'SUNTRUST_BEVERLEY_ST_BRANCH',
  SuntrustBroadStBranch = 'SUNTRUST_BROAD_ST_BRANCH',
  Super8MotelStaunton = 'SUPER_8_MOTEL_STAUNTON',
  SuperShoes = 'SUPER_SHOES',
  SurrattTireInc = 'SURRATT_TIRE_INC',
  SwannConstructionCompany = 'SWANN_CONSTRUCTION_COMPANY',
  SyscoFoodServicesOfVa = 'SYSCO_FOOD_SERVICES_OF_VA',
  TacoBell = 'TACO_BELL',
  TacoBellOfWaynesboro = 'TACO_BELL_OF_WAYNESBORO',
  TacoBellStaunton = 'TACO_BELL_STAUNTON',
  TailgateGrill = 'TAILGATE_GRILL',
  TargetDistributionCenter = 'TARGET_DISTRIBUTION_CENTER',
  TargetStoreWaynesboro = 'TARGET_STORE_WAYNESBORO',
  TasteeFreezeChurchvilleVa = 'TASTEE_FREEZE_CHURCHVILLE_VA',
  TasteeFreezeWBeverly = 'TASTEE_FREEZE_W_BEVERLY',
  TexasSteakhouseAndSaloon = 'TEXAS_STEAKHOUSE_AND_SALOON',
  TheBradfordCompany = 'THE_BRADFORD_COMPANY',
  TheCheeseShop = 'THE_CHEESE_SHOP',
  TheFishingPigFarmville = 'THE_FISHING_PIG_FARMVILLE',
  TheFishingPigWaynesboro = 'THE_FISHING_PIG_WAYNESBORO',
  TheHomeDepotStore4654 = 'THE_HOME_DEPOT_STORE_4654',
  TheLegacyAtNorthAugusta = 'THE_LEGACY_AT_NORTH_AUGUSTA',
  TheLodgeAtOldTrail = 'THE_LODGE_AT_OLD_TRAIL',
  TheLycraCompany = 'THE_LYCRA_COMPANY',
  ThePilotTravelCenter = 'THE_PILOT_TRAVEL_CENTER',
  ThePurpleFoot = 'THE_PURPLE_FOOT',
  TireMart = 'TIRE_MART',
  TjMaxx = 'TJ_MAXX',
  ToddBrothersContractors = 'TODD_BROTHERS_CONTRACTORS',
  TransitMixConcreteCo = 'TRANSIT_MIX_CONCRETE_CO',
  TransportationPatient = 'TRANSPORTATION_PATIENT',
  TransprintUsa = 'TRANSPRINT_USA',
  TruckEnterprisesInc = 'TRUCK_ENTERPRISES_INC',
  TruckThermoKing = 'TRUCK_THERMO_KING',
  TycoElectronics = 'TYCO_ELECTRONICS',
  TycoElectronicsMtSidney = 'TYCO_ELECTRONICS_MT_SIDNEY',
  TysonFoodsInc = 'TYSON_FOODS_INC',
  Unemployed = 'UNEMPLOYED',
  UnifiIncStauntonPlant = 'UNIFI_INC_STAUNTON_PLANT',
  UnionFirstBankStaunton = 'UNION_FIRST_BANK_STAUNTON',
  UnionFirstBankStuartsDra = 'UNION_FIRST_BANK_STUARTS_DRA',
  UnionFirstBankWaynesboro = 'UNION_FIRST_BANK_WAYNESBORO',
  UnitedParcelServiceCville = 'UNITED_PARCEL_SERVICE_CVILLE',
  UnitedParcelServiceFisvill = 'UNITED_PARCEL_SERVICE_FISVILL',
  UniversalImpactStaunton = 'UNIVERSAL_IMPACT_STAUNTON',
  UniversalImpactWaynesboro = 'UNIVERSAL_IMPACT_WAYNESBORO',
  UniversityOfVirginia = 'UNIVERSITY_OF_VIRGINIA',
  Unknown = 'UNKNOWN',
  UPMC = 'UPMC',
  Usda = 'USDA',
  USPostalServiceBlueGrass = 'U_S_POSTAL_SERVICE_BLUE_GRASS',
  VaAbcStoreStateStStaunton = 'VA_ABC_STORE_STATE_ST_STAUNTON',
  VaAbcStoreStuartsDraft = 'VA_ABC_STORE_STUARTS_DRAFT',
  VaAbcStoreVerona = 'VA_ABC_STORE_VERONA',
  VaAbcStoreWaynesboro = 'VA_ABC_STORE_WAYNESBORO',
  VaAugustaCorrectionalCenter = 'VA_AUGUSTA_CORRECTIONAL_CENTER',
  VaDepartOfHealthLexington = 'VA_DEPART_OF_HEALTH/LEXINGTON',
  VaDeptGameInlandFisheries = 'VA_DEPT_GAME_INLAND_FISHERIES',
  VaDeptOfRehabilitativeSvs = 'VA_DEPT_OF_REHABILITATIVE_SVS',
  VaDeptOfTransporationVdot = 'VA_DEPT_OF_TRANSPORATION_VDOT',
  VaDmvStaunton = 'VA_DMV_STAUNTON',
  VaDmvWaynesboro = 'VA_DMV_WAYNESBORO',
  VailesBrotherInc = 'VAILES_BROTHER_INC',
  ValleyBlox = 'VALLEY_BLOX',
  ValleyBuildingSupply = 'VALLEY_BUILDING_SUPPLY',
  ValleyCommunityServices = 'VALLEY_COMMUNITY_SERVICES',
  ValleyCraneAndRigging = 'VALLEY_CRANE_AND_RIGGING',
  ValleyCreditService = 'VALLEY_CREDIT_SERVICE',
  ValleyHonda = 'VALLEY_HONDA',
  ValleyMission = 'VALLEY_MISSION',
  ValleyNissan = 'VALLEY_NISSAN',
  ValleyOfficeMachinesEquip = 'VALLEY_OFFICE_MACHINES_EQUIP',
  ValleyOilCorporation = 'VALLEY_OIL_CORPORATION',
  ValleyPool = 'VALLEY_POOL',
  ValleyPoolSpaStaunton = 'VALLEY_POOL_SPA_STAUNTON',
  ValleyPrecisionInc = 'VALLEY_PRECISION_INC',
  ValleyProgramForAgingSvs = 'VALLEY_PROGRAM_FOR_AGING_SVS',
  ValleystarCreditUnion = 'VALLEYSTAR_CREDIT_UNION',
  ValleyVocTechCenter = 'VALLEY_VOC_TECH_CENTER',
  VanWykInc = 'VAN_WYK_INC',
  VaSchoolForDeafAndBlind = 'VA_SCHOOL_FOR_DEAF_&_BLIND',
  VectorIndustriesInc = 'VECTOR_INDUSTRIES_INC',
  Verizon = 'VERIZON',
  VillageGardenCenter = 'VILLAGE_GARDEN_CENTER',
  VirginiaAbcStoreGreenAve = 'VIRGINIA_ABC_STORE_GREEN_AVE',
  VirginiaDeptOfMentalHealth = 'VIRGINIA_DEPT_OF_MENTAL_HEALTH',
  VirginiaEmploymentCommission = 'VIRGINIA_EMPLOYMENT_COMMISSION',
  VirginiaFrameBuilderSuppl = 'VIRGINIA_FRAME_BUILDER_SUPPL',
  VirginiaHorseCenter = 'VIRGINIA_HORSE_CENTER',
  VirginiaMetalcrafters = 'VIRGINIA_METALCRAFTERS',
  VirginiaMilitaryInstitute = 'VIRGINIA_MILITARY_INSTITUTE',
  VirginiaPanelCorp = 'VIRGINIA_PANEL_CORP',
  VirginiaRegionalTransit = 'VIRGINIA_REGIONAL_TRANSIT',
  VirginiaStatePolice = 'VIRGINIA_STATE_POLICE',
  WaffleHouseStaunton = 'WAFFLE_HOUSE_STAUNTON',
  WaffleHouseWaynesboro = 'WAFFLE_HOUSE_WAYNESBORO',
  WalkerManufacturingCo = 'WALKER_MANUFACTURING_CO',
  WallaceCharlesDds = 'WALLACE_CHARLES_DDS',
  WalmartDistributionCenter = 'WALMART_DISTRIBUTION_CENTER',
  WalmartGordonsvilleVa = 'WALMART_GORDONSVILLE_VA',
  WalmartHarrisonburgBurgess = 'WALMART_HARRISONBURG_BURGESS',
  WalmartHarrisonburgJohnWayl = 'WALMART_HARRISONBURG_JOHN_WAYL',
  WalmartLexington = 'WALMART_LEXINGTON',
  WalmartNeighborMarketHburg = 'WALMART_NEIGHBOR_MARKET_HBURG',
  WalmartNeighborMarketWayne = 'WALMART_NEIGHBOR_MARKET_WAYNE',
  WalMartOfStaunton = 'WAL_MART_OF_STAUNTON',
  WalMartOfWaynesboro = 'WAL_MART_OF_WAYNESBORO',
  WashingtonAndLeeUniversity = 'WASHINGTON_AND_LEE_UNIVERSITY',
  WayneLanes = 'WAYNE_LANES',
  WaynesboroCityOf = 'WAYNESBORO_CITY_OF',
  WaynesboroCitySchools = 'WAYNESBORO_CITY_SCHOOLS',
  WaynesboroCityShop = 'WAYNESBORO_CITY_SHOP',
  WaynesboroCountyClub = 'WAYNESBORO_COUNTY_CLUB',
  WaynesboroFireDepartment = 'WAYNESBORO_FIRE_DEPARTMENT',
  WaynesboroFirstAidCrew = 'WAYNESBORO_FIRST_AID_CREW',
  WaynesboroHealthDept = 'WAYNESBORO_HEALTH_DEPT',
  WaynesboroLandscapeGarden = 'WAYNESBORO_LANDSCAPE_GARDEN',
  WaynesboroManor = 'WAYNESBORO_MANOR',
  WaynesboroNewsVirginian = 'WAYNESBORO_NEWS_VIRGINIAN',
  WaynesboroNurseries = 'WAYNESBORO_NURSERIES',
  WaynesboroPostOffice = 'WAYNESBORO_POST_OFFICE',
  WaynesboroPostOffPkStation = 'WAYNESBORO_POST_OFF_PK_STATION',
  WebsterAndWebster = 'WEBSTER_AND_WEBSTER',
  WelderSupply = 'WELDER_SUPPLY',
  WellsFargoRoanokeOffice = 'WELLS_FARGO_ROANOKE_OFFICE',
  WellsFargoWaynesboro = 'WELLS_FARGO_WAYNESBORO',
  WendysFamilyRestaurant = 'WENDYS_FAMILY_RESTAURANT',
  WendysFishersville = 'WENDYS_FISHERSVILLE',
  WendysStaunton = 'WENDYS_STAUNTON',
  WendysVerona = 'WENDYS_VERONA',
  WendysWaynesboro = 'WENDYS_WAYNESBORO',
  WesternStateHospital = 'WESTERN_STATE_HOSPITAL',
  WesthillsCompany = 'WESTHILLS_COMPANY',
  WestSandAndGravelCoInc = 'WEST_SAND_AND_GRAVEL_CO_INC',
  WestwoodAnimalHospital = 'WESTWOOD_ANIMAL_HOSPITAL',
  WetselSeedCompany = 'WETSEL_SEED_COMPANY',
  WheatleyMotorCarCompany = 'WHEATLEY_MOTOR_CAR_COMPANY',
  WhitesellsSalesAndService = 'WHITESELLS_SALES_AND_SERVICE',
  WhitesTruckStop = 'WHITES_TRUCK_STOP',
  WildlifeCenterOfVirginia = 'WILDLIFE_CENTER_OF_VIRGINIA',
  WilhelmInsuranceCompany = 'WILHELM_INSURANCE_COMPANY',
  WillowTreeAcademy = 'WILLOW_TREE_ACADEMY',
  WilsonTruckingCo = 'WILSON_TRUCKING_CO',
  WilsonWorkforceRehabCenter = 'WILSON_WORKFORCE_REHAB_CENTER',
  WineJBAndSonsContractors = 'WINE_J_B_AND_SONS_CONTRACTORS',
  WintergreenPoliceDept = 'WINTERGREEN_POLICE_DEPT',
  WintergreenResort = 'WINTERGREEN_RESORT',
  WniIndustrialServices = 'WNI_INDUSTRIAL_SERVICES',
  WVUMedicine = 'WVU_MEDICINE',
  WoodForestNationalBank = 'WOOD_FOREST_NATIONAL_BANK',
  WtonOgdenBroadcastingOfVa = 'WTON_OGDEN_BROADCASTING_OF_VA',
  WvirTv = 'WVIR_TV',
  YanceyLumberyard = 'YANCEY_LUMBERYARD',
  YellowFreightSysIncStaunto = 'YELLOW_FREIGHT_SYS_INC_STAUNTO',
  YellowRoadwayCorporation = 'YELLOW_ROADWAY_CORPORATION',
  YmcaStaunton = 'YMCA_STAUNTON',
  YmcaWaynesboro = 'YMCA_WAYNESBORO',
  ZeusDigitalTheater = 'ZEUS_DIGITAL_THEATER',
}

export interface EmployerFormFieldValue {
  employer: Employer;
  employerRaw: string;
}
